import { Injectable, InjectionToken } from '@angular/core';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiSpecialization } from '../api-types/specialization.api';
import { Specialization } from '../app-types/specialization.app';
import { transformApiSpecializationsToAppSpecializations } from '../transformers/specialization.transform';
import { BaseRequestService } from './base-request.service';

export const SPECIALIZATION_SERVICE = new InjectionToken<SpecializationService>('SPECIALIZATION_SERVICE');

@Injectable()
export class SpecializationService extends BaseRequestService {
	public async getAll(searchTerm?: string, offset?: number, range?: number) {
		const response = await this.get<PaginatedResponse<ApiSpecialization>>('categories/specializations', {
			searchTerm,
			offset,
			range,
		});
		const specializations = transformApiSpecializationsToAppSpecializations(response.entities);
		const page: PaginatedResponse<Specialization> = {
			entities: specializations,
			offset: response.offset,
			range: response.range,
			totalEntities: response.totalEntities,
		};
		return page;
	}
}
